import React from 'react'
import { Slice } from 'gatsby'

export default function Layout({ theme, mobileTheme, children }) {
  return (
    <>
      <Slice alias="header" theme={theme} mobileTheme={mobileTheme} />
      <main>{children}</main>
      <Slice alias="footer" />
    </>
  )
}
